"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedInlineTagsAndAttrs = exports.allowedBlockTagsAndAttrs = exports.allowedHtmlGlobalAttrs = exports.allRendererMethods = void 0;
exports.allRendererMethods = [
    'code',
    'blockquote',
    'html',
    'heading',
    'hr',
    'list',
    'listitem',
    'checkbox',
    'paragraph',
    'table',
    'tablerow',
    'tablecell',
    'strong',
    'em',
    'codespan',
    'br',
    'del',
    'link',
    'image',
    'text',
];
exports.allowedHtmlGlobalAttrs = ['title', 'lang'];
exports.allowedBlockTagsAndAttrs = {
    blockquote: exports.allowedHtmlGlobalAttrs,
    br: exports.allowedHtmlGlobalAttrs,
    code: exports.allowedHtmlGlobalAttrs,
    hr: exports.allowedHtmlGlobalAttrs,
    h1: exports.allowedHtmlGlobalAttrs,
    h2: exports.allowedHtmlGlobalAttrs,
    h3: exports.allowedHtmlGlobalAttrs,
    h4: exports.allowedHtmlGlobalAttrs,
    h5: exports.allowedHtmlGlobalAttrs,
    h6: exports.allowedHtmlGlobalAttrs,
    iframe: [
        ...exports.allowedHtmlGlobalAttrs,
        'allow',
        'allowfullscreen',
        'height',
        'src',
        'width',
    ],
    li: exports.allowedHtmlGlobalAttrs,
    ol: exports.allowedHtmlGlobalAttrs,
    p: exports.allowedHtmlGlobalAttrs,
    pre: exports.allowedHtmlGlobalAttrs,
    ul: exports.allowedHtmlGlobalAttrs,
};
exports.allowedInlineTagsAndAttrs = {
    a: [...exports.allowedHtmlGlobalAttrs, 'href'],
    b: exports.allowedHtmlGlobalAttrs,
    em: exports.allowedHtmlGlobalAttrs,
    img: [...exports.allowedHtmlGlobalAttrs, 'src', 'alt', 'width', 'height'],
    span: exports.allowedHtmlGlobalAttrs,
    strong: exports.allowedHtmlGlobalAttrs,
};
//# sourceMappingURL=config.js.map